import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const contactBlockDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.contact,
  componentType: LAYOUT_COMPONENT_TYPE.contactBlock,
  registryBlockKey: REGISTRY_BLOCK.presentation.contactVisit,
  displayOrder: 8,
  content: {
    sectionIcon: loc3('MapPin', 'MapPin', 'MapPin'),
    sectionTitle: loc3('Kontakt', 'Contact', 'Liên hệ'),
    intro: loc3(
      'Schreiben Sie uns, oder kommen Sie vorbei — die Küche ist zu Fuß vom Isartor.',
      'Write to us, or come by — the kitchen is a short walk from Isartor.',
      'Viết cho chúng tôi, hoặc ghé qua — bếp cách Isartor vài bước chân.',
    ),
    address: loc3(
      'Mühlgasse 8 · 80469 München',
      '8 Mühlgasse · Munich',
      '8 Mühlgasse · Munich',
    ),
    directions: loc3(
      'Zwei Minuten vom Isartor — Fahrradständer vor der Tür.',
      'Two minutes from Isartor — bike racks at the door.',
      'Cách Isartor hai phút — chỗ để xe đạp trước cửa.',
    ),
    phone: loc3('+49 89 1200 4480', '+49 89 1200 4480', '+49 89 1200 4480'),
    email: loc3('hallo@aurora.example', 'hello@aurora.example', 'hello@aurora.example'),
    hours: loc3(
      'Mo–Fr 12:00–14:30, 18:00–22:00\nSa 18:00–23:00\nSo geschlossen',
      'Mon–Fri 12:00–14:30, 18:00–22:00\nSat 18:00–23:00\nSun closed',
      'Thứ Hai–Thứ Sáu 12:00–14:30, 18:00–22:00\nThứ Bảy 18:00–23:00\nChủ Nhật Đóng cửa',
    ),
    formHeading: loc3('Nachricht', 'Message', 'Tin nhắn'),
    formSupporting: loc3(
      'Für Fragen, die keine Reservierung sind — wir antworten am nächsten Werktag.',
      'For questions that are not a reservation — we reply on the next working day.',
      'Cho câu hỏi không phải đặt bàn — chúng tôi trả lời vào ngày làm việc kế tiếp.',
    ),
    consent: loc3(
      'Ich stimme der Verarbeitung meiner Angaben zu.',
      'I agree to the processing of my details.',
      'Tôi đồng ý xử lý thông tin của mình.',
    ),
    ctaLabel: loc3('Nachricht senden', 'Send message', 'Gửi tin nhắn'),
  },
  media: {
    mapImage:
      'https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=1400&q=80',
  },
  dataBinding: { kind: 'form', formKey: 'contact' },
};

export const contactDeskDefault: LayoutBlock = {
  ...contactBlockDefault,
  blockId: FIXTURE_BLOCK_IDS.contactDesk,
  registryBlockKey: REGISTRY_BLOCK.presentation.contactDesk,
};

export const contactLedgerDefault: LayoutBlock = {
  ...contactBlockDefault,
  blockId: FIXTURE_BLOCK_IDS.contactLedger,
  registryBlockKey: REGISTRY_BLOCK.presentation.contactLedger,
};

export const contactThresholdDefault: LayoutBlock = {
  ...contactBlockDefault,
  blockId: FIXTURE_BLOCK_IDS.contactThreshold,
  registryBlockKey: REGISTRY_BLOCK.presentation.contactThreshold,
};
